import { useState, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LocalizedLink } from "@/components/LocalizedLink";
import { updateConsent } from "@/lib/analytics";

const STORAGE_KEY = "fluxabee_cookie_consent";
export const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      setVisible(!localStorage.getItem(STORAGE_KEY));
    } catch {
      setVisible(true);
    }
  }, []);
  const choose = (accepted: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, accepted ? "accepted" : "declined");
    } catch {
      /* Consent still applies for this visit. */
    }
    updateConsent(accepted);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <section className="field-cookies" aria-label={t("cookie.privacyLink")}>
      <p>
        {t("cookie.message")}{" "}
        <LocalizedLink to="/privacy">{t("cookie.privacyLink")}</LocalizedLink>.
      </p>
      <div>
        <button
          type="button"
          className="field-button field-button-secondary"
          onClick={() => choose(false)}
        >
          {t("cookie.decline")}
        </button>
        <button
          type="button"
          className="field-button"
          onClick={() => choose(true)}
        >
          {t("cookie.accept")}
        </button>
      </div>
    </section>
  );
};
